import { gql } from "@apollo/client";

import { GET_SINGLE_USER_ACCOUNT } from "@/graphql-client/fragments";

export const GET_SINGLE_USER = gql`
  query GetSingleUser($userId: Int!) {
    account(id: $userId) {
      ...GetSingleUserAccount
    }
  }
  ${GET_SINGLE_USER_ACCOUNT}
`;

export const CREATE_CALL_SCHEDULE = gql`
  mutation CreateCallSchedule(
    $cronExpression: String!
    $accountId: Int!
    $callFlowVersion: CallFlowVersion!
  ) {
    createCallSchedule(
      data: {
        cronExpression: $cronExpression
        accountId: $accountId
        callFlowVersion: $callFlowVersion
      }
    ) {
      id
    }
  }
`;

export const UPDATE_CALL_SCHEDULE = gql`
  mutation UpdateCallSchedule($id: Int!, $cronExpression: String!) {
    updateCallSchedule(id: $id, data: { cronExpression: $cronExpression }) {
      id
    }
  }
`;

export const GET_DELETED_CALL_SCHEDULES = gql`
  query GetDeletedCallSchedules($userId: Int!) {
    deletedCallSchedules(accountId: $userId) {
      id
      cronExpression
      scheduleDescription
      callFlowVersion
      createdOn
    }
  }
`;

export const DELETE_CALL_SCHEDULE = gql`
  mutation DeleteCallSchedule($id: Int!) {
    deleteCallSchedule(id: $id) {
      id
    }
  }
`;

export const RESTORE_CALL_SCHEDULE = gql`
  mutation RestoreCallSchedule($id: Int!) {
    restoreCallSchedule(id: $id) {
      id
    }
  }
`;
export const TRANSCRIBE_CALL = gql`
  query GetTranscribe($callSid: String!) {
    transcribe(callSid: $callSid) {
      code
      message
      data
    }
  }
`;

export const SEND_ACCESS_NOTIFICATION = gql`
  mutation SendAccessNotification($accountId: Int!, $accessedBy: String!, $source: String!) {
    createAccessRecord(data: { accountId: $accountId, accessedBy: $accessedBy, source: $source }) {
      id
    }
  }
`;
